import get from 'lodash/get';

export const getArcadeArcade = state => get(state, 'arcade.arcade', {});
export const getArcadeId = state => get(getArcadeArcade(state), 'id');
export const getArcadeMainRoomId = state => get(getArcadeArcade(state), 'mainRoomId');
